<template>
  <div class="product-position-sheet">
    <p class="sheet-title">{{ $t('all_address') }}</p>

    <div class="sheet-content--map">
      <div class="d-flex justify-space-between align-self-start">
        <div class="address-info">
          <p ref="branchAddress" class="branch-address mb-1">{{ fullAddress }}</p>

          <client-only>
            <v-tooltip v-model="showCopySuccess" color="black50" location="top">
              <template #activator="{ props: tooltipProps }">
                <v-btn
                  :ref="tooltipProps.ref"
                  class="action__btn copy-address__btn mb-4"
                  color="orange50"
                  :max-height="32"
                  variant="text"
                  @click="copyAddress"
                >
                  {{ $t('copy_address') }}
                </v-btn>
              </template>

              <span> {{ $t('copy_success') }} </span>
            </v-tooltip>
          </client-only>
        </div>

        <div v-if="breakpoints.xs" @click="openBranchMapModal">
          <funnow-icon max-width="60" :image-path="'map-icon.svg'" />
        </div>
      </div>

      <iframe v-if="!breakpoints.xs" width="100%" height="272" frameborder="0" :src="googleMapEmbedSrc" allowfullscreen />
    </div>

    <!-- 大眾交通 -->
    <div v-if="!!product.transportation" class="sub-content__block">
      <v-divider class="sheet__divider" />

      <p class="sheet-title">{{ $t('all_traffic') }}</p>

      <div class="sheet-content">
        <bullet-text :content="product.transportation" />
      </div>
    </div>

    <!-- 附近景點 -->
    <div v-if="!!product.nearby_spot" class="sub-content__block">
      <v-divider class="sheet__divider" />

      <div class="expansion-panel d-flex justify-space-between align-center" @click="openNearByBtn = !openNearByBtn">
        <p class="sheet-title">{{ $t('product_nearby') }}</p>

        <v-btn class="mr-4" color="gray50" min-width="32" width="32" height="32" variant="text">
          <funnow-icon max-width="20" :image-path="`chevron-${openNearByBtn ? 'up' : 'down'}.svg`" />
        </v-btn>
      </div>

      <div v-if="openNearByBtn" class="sheet-content">
        <bullet-text :content="product.nearby_spot" />
      </div>
    </div>

    <!-- 營業時間 -->
    <div v-if="!!product.opening_hours" class="sub-content__block">
      <v-divider class="sheet__divider" />

      <div class="expansion-panel d-flex justify-space-between align-center" @click="openHourBtn = !openHourBtn">
        <p class="sheet-title">{{ $t('open_hour') }}</p>

        <v-btn class="mr-4" color="gray50" min-width="32" width="32" height="32" variant="text">
          <funnow-icon max-width="20" :image-path="`chevron-${openHourBtn ? 'up' : 'down'}.svg`" />
        </v-btn>
      </div>

      <div v-if="openHourBtn" class="sheet-content">
        <bullet-text :content="product.opening_hours" />
      </div>
    </div>

    <branch-map-modal ref="branchMapModal" :branch="branch" />
  </div>
</template>
<script setup lang="ts">
import { useBreakpoints } from '@/composition/useBreakpoints'

import BulletText from '@/components/BulletText.vue'
import BranchMapModal from '@/components/dialog/branch-map-modal.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import { useAutoResetClipBoard } from '@/composition/useUtil'

defineOptions({
  name: 'ProductPositionSheet',
})

const props = defineProps<{
  branch: any
  product: any
}>()

const { product } = toRefs(props)

const { breakpoints } = useBreakpoints()

const openNearByBtn = ref(false)
const openHourBtn = ref(false)
const branchMapModal = useTemplateRef('branchMapModal')

const { fullAddress, googleMapEmbedSrc } = useAddress(product)
const { copy: copyAddress, copiedAutoReset: showCopySuccess } = useAutoResetClipBoard(fullAddress)

function openBranchMapModal() {
  branchMapModal.value?.showModal()
}
</script>
<style lang="scss" scoped>
.copy-address__btn {
  margin-left: -16px;
}
</style>
